<template>
  <div
    :class="[
      'coupon-wrapper',
      {
        [`theme__${themeColor}`]: themeColor,
        coupon__disabled: isDisabled,
        coupon__lock: isLock,
        en: isEn,
      },
    ]"
    @click="couponClick"
  >
    <!-- 左上角 tag -->
    <div
      :class="['coupon-tag', { [`coupon-tag__${couponInfo.couponTagColor}`]: couponInfo.couponTagColor }]"
      v-if="couponInfo.couponTagText"
    >
      {{ couponInfo.couponTagText }}
    </div>
    <div :class="['coupon-content', { sp: couponInfo.spDesc }]" role="text" :aria-label="couponAiraLabel">
      <!-- 商户信息 -->
      <div class="coupon-sp" v-if="couponInfo.spDesc" role="text" :aria-label="couponAiraLabel">
        <!-- 普通券，带奖品logo -->
        <div class="prize-logo" aria-hidden="true">
          <img :src="couponInfo.prizeLogo || couponInfo.spLogo" alt="prize logo(優惠券獎品logo)" />
        </div>
        <div class="coupon-sp-info">{{ couponInfo.spDesc }}</div>
      </div>
      <!-- 券信息 -->
      <template>
        <Amount
          v-if="isDiscountCoupon"
          :currencyType="currencyType"
          :prizeAmountPenny="couponInfo.prizeDiscount"
          :zoomRatio="1.28"
          :isDiscount="isDiscountCoupon"
        ></Amount>
        <Amount
          v-else
          :currencyType="currencyType"
          :prizeAmountYuan="couponInfo.prizeAmountYuan"
          :zoomRatio="1.28"
        ></Amount>
      </template>
      <!-- 券描述 -->
      <div class="coupon-desc">{{ couponInfo.prizeDesc }}</div>
      <!-- 邮戳 -->
      <div class="coupon-stamp" v-if="isShowStamp">
        <div class="coupon-stamp-inner">
          <div class="coupon-stamp-txt" v-html="couponInfo.stampText"></div>
        </div>
      </div>
    </div>
    <div class="coupon-op">
      <!-- 券按钮 -->
      <div
        v-if="isShowButton"
        v-stat.click="{
          tag: 'comp-coupon-exchange.item-exchange',
          ext: { fprizeAmountYuan: couponInfo.prizeAmountYuan },
        }"
        @click.stop="handleExchange"
        :class="[
          'button',
          'font-24-regular',
          { [`button__${couponInfo.buttonType}`]: couponInfo.buttonType },
          { [`${enButtionStyle}`]: enButtionStyle },
        ]"
        role="button"
      >
        <!-- 不需要锁icon -->
        {{ couponInfo.couponBtnText }}
        <slot name="coupon-btn-ui"></slot>
      </div>
      <!-- 库存提示 -->
      <span class="tips-text" v-else-if="isShowTips">
        {{ couponInfo.tipsText }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import CouponMixinV2 from './mixin/mixin-v2.vue';
import { CouponButtonType } from './types';

@Component
export default class Coupon extends mixins(CouponMixinV2) {
  /**
   * 不需要的 props
   * prizeName
   * couponTagText
   * couponTagColor
   * themeColor
   * isChain
   * isShowShadow
   * pkgInfo
   * pkgCount
   * themeLogo
   * tipsTextRight
   * goodsUrl
   */

  /** 券是否不可用，不可用时灰白色 */
  get isDisabled() {
    return this.couponInfo.buttonType === CouponButtonType.disabled;
  }

  /** 券无障碍展示内容 */
  get couponAiraLabel() {
    const { spDesc, prizeName } = this.couponInfo;
    return this.parseCurrencyAria([spDesc, prizeName].join(' '), true, this.currencyType);
  }
}
</script>

<style lang="less" scoped>
@import './less/coupon-small.less';
</style>
